import script from "./EmployeeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeList.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeList.vue?vue&type=style&index=0&id=35c637c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c637c8"]])

export default __exports__